<style>
</style>
<template>
<div>
  <v-tooltip bottom v-if="item.hasInvoice">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" v-on="on" @click.native.stop="downloadInvoice(item)">
        <v-icon color="green" class="fa fa-download"></v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Faktura') }}</span>
  </v-tooltip>
  <v-tooltip bottom v-if="item.hasInvoice">
    <template v-slot:activator="{ on }">
      <v-btn icon class="mx-0" v-on="on" @click.native.stop="resendEmail(item)">
        <v-icon color="green" class="">mail</v-icon>
      </v-btn>
    </template>
    <span>{{ $t('Zaslat email') }}</span>
  </v-tooltip>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="headline">{{ $t('Upozornění') }}</v-card-title>
      <v-card-text>{{ $t(dialogText) }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="dialogText = null">{{ $t('Zavřít') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'

const download = require('downloadjs')

export default {
  props: {
    expanded: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mixins: [BasketMixin],
  data() {
    return {
      dialogText: null
    }
  },
  computed: {
    dialog: {
      get() {
        return (this.dialogText !== null)
      },
      set(value) {
        if (value) {
          this.dialogText = null
        }
      }
    }
  },
  methods: {
    invoiceName(response) {
      var name = 'faktura.pdf'
      var disposition = response.headers.get('Content-Disposition')
      if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        var matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          name = matches[1].replace(/['"]/g, '')
        }
      }
      return name
    },
    resendEmail(basket) {
      this.$fetch('my/baskets/' + basket.basketId + '/email').then(() => {
        this.dialogText = 'Úspěšné odeslání emailu'
      }).catch(() => {
        this.dialogText = 'Odeslání emailu se nepodařilo'
        console.log('resend email error')
      })
    },
    downloadInvoice(basket) {
      const options = {
        headers: {
          'content-type': 'application/pdf'
        },
        'response-type': 'blob'
      }
      this.$fetch('my/baskets/' + basket.basketId + '/invoice', options).then(response => response.blob()
          .then(blob => download(blob, this.invoiceName(response), 'application/pdf')))
        .catch(() => {
          this.dialogText = 'Stažení faktury se nepodařilo'
          console.log('download invoice error')
        })
    }
  }
}
</script>
